import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  border: "1",
  cellpadding: "1",
  cellspacing: "1"
}
const _hoisted_2 = ["alt", "src"]
const _hoisted_3 = {
  key: 0,
  style: {"color":"#2980b9"}
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  border: "1",
  cellpadding: "1",
  cellspacing: "1"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  style: {"color":"#2980b9"}
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  style: {"color":"#2980b9"}
}
const _hoisted_11 = { key: 2 }


export default /*@__PURE__*/_defineComponent({
  __name: 'imageTableTitle',
  props: {
    ImageTitleCollection: { default: () => [] },
    tableImage: { type: Boolean, default: false },
    wrap: { type: Boolean, default: false },
    center: { type: Boolean, default: false },
    span: { default: 6 },
    strong: { type: Boolean, default: false },
    h2Title: {},
    h3Title: {},
    pTitle: {},
    hasArrow: { type: Boolean, default: false },
    titleCenter: { type: Boolean, default: false },
    hasHr: { type: Boolean, default: true },
    lineHeight: { default: 1.5 }
  },
  setup(__props: any) {


const props = __props;


return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.h2Title)
      ? (_openBlock(), _createElementBlock("h2", {
          key: 0,
          style: _normalizeStyle({ 'text-align': _ctx.titleCenter ? 'center' : 'left' })
        }, _toDisplayString(_ctx.h2Title), 5))
      : _createCommentVNode("", true),
    (_ctx.h3Title)
      ? (_openBlock(), _createElementBlock("h3", {
          key: 1,
          style: _normalizeStyle({ 'text-align': _ctx.titleCenter ? 'center' : 'left' })
        }, _toDisplayString(_ctx.h3Title), 5))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pTitle, (item, index) => {
      return (_openBlock(), _createElementBlock("p", {
        key: index,
        style: _normalizeStyle({ 'text-align': _ctx.titleCenter ? 'center' : 'left', 'line-height': _ctx.lineHeight })
      }, _toDisplayString(item), 5))
    }), 128)),
    _createVNode(_component_el_row, {
      class: "content",
      gutter: 30
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ImageTitleCollection, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_col, {
            xs: 12,
            sm: 12,
            md: _ctx.span,
            lg: _ctx.span,
            key: index
          }, {
            default: _withCtx(() => [
              (_ctx.tableImage)
                ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("img", {
                            alt: item.alt,
                            src: item.imgUrl
                          }, null, 8, _hoisted_2)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", {
                          style: _normalizeStyle({ 'white-space': _ctx.wrap ? 'wrap' : 'nowrap', 'text-align': _ctx.center ? 'center' : 'left' })
                        }, [
                          _createTextVNode(_toDisplayString(item.title) + " ", 1),
                          (_ctx.hasArrow)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "▶"))
                            : _createCommentVNode("", true)
                        ], 4)
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("img", {
                      src: item.imgUrl,
                      alt: item.alt
                    }, null, 8, _hoisted_5),
                    _createElementVNode("table", _hoisted_6, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", {
                            style: _normalizeStyle({ 'white-space': _ctx.wrap ? 'wrap' : 'nowrap', 'text-align': _ctx.center ? 'center' : 'left' })
                          }, [
                            (_ctx.strong)
                              ? (_openBlock(), _createElementBlock("strong", _hoisted_7, [
                                  _createTextVNode(_toDisplayString(item.title) + " ", 1),
                                  (_ctx.hasArrow)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "▶"))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                  _createTextVNode(_toDisplayString(item.title) + " ", 1),
                                  (_ctx.hasArrow)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, "▶"))
                                    : _createCommentVNode("", true)
                                ]))
                          ], 4)
                        ])
                      ])
                    ])
                  ]))
            ]),
            _: 2
          }, 1032, ["md", "lg"]))
        }), 128))
      ]),
      _: 1
    }),
    (_ctx.hasHr)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_11))
      : _createCommentVNode("", true)
  ], 64))
}
}

})